import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-update',
  templateUrl: './document-update.component.html',
  styleUrls: ['./document-update.component.scss']
})
export class DocumentUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
